export default {
  connected: 'Associate accounts',
  perfectInfo: 'Update profile',
  agree: 'Login approvals',
  confirm: 'Confirm',
  haveAccount: 'Already had an account? ',
  noAccount: 'Sign up'
}



// WEBPACK FOOTER //
// ./src/lang/en/oauth.js